import React from 'react';
import { required, SelectInput, DateField, Toolbar, SaveButton, Filter, Create, Edit, List, Datagrid, FunctionField, 
  TextField, TextInput, BooleanInput, SimpleForm, FormTab, ArrayField, SelectArrayInput, FormDataConsumer, 
  ReferenceArrayInput, AutocompleteArrayInput, downloadCSV, useListContext, TopToolbar, sanitizeListRestProps, 
  FilterButton, CreateButton, ExportButton} from 'react-admin';
import jsonExport from 'jsonexport/dist';

const IABCategoryChoices = require('./components/iab_categories.json');
const googleAdsCategoryChoices = require('./components/google_advertiser_verticals.json')

const exporter = sites => {
  const sitesForExport = sites.map(site => {
    let bidderAuditStatus = [];
    if (site.bidder_audit_status) for (const key of Object.keys(site.bidder_audit_status)) {
      const message = site.bidder_audit_status[key].message ? ` (${site.bidder_audit_status[key].message})` : '';
      bidderAuditStatus.push(`${key} ${site.bidder_audit_status[key].status}${message}`);
    }
    let o = {
        id: site.code,
        name: site.name,
        type: site.type,
        audit_status: bidderAuditStatus.join('|')
    };
    return o;
  });
  jsonExport(sitesForExport, {
      headers: ['id', 'name', 'type', 'audit_status', 'audit_reason']
  }, (err, csv) => {
      downloadCSV(csv, 'sites');
  });
};

const DomainTitle = ({ record }) => {
  return <span> Domain {record ? `"${record.name}"` : ''} </span>
};
const domainFilters = [
  <TextInput label="Search" source="search_name" alwaysOn resettable />
];
const CustomToolbar = props => (
	<Toolbar {...props}>
		<SaveButton />
		<br />
		<DateField source="updated_at" label="Update date" style={{ padding: '10px' }} showTime />
		<TextField source="updated_name" label="" style={{ padding: '10px' }} />
	</Toolbar>
);
const ListActions = (props) => {
  const { className, maxResults, ...rest } = props;
  const { total } = useListContext();
  return (
      <TopToolbar className={className} {...sanitizeListRestProps(rest)}>
          <FilterButton />
          <CreateButton />
          <ExportButton disabled={total === 0} maxResults={10000} exporter={exporter}/>
      </TopToolbar>
  );
};
export const AdvertiserDomainList = (props) => (
	<List {...props} title="Domains" 
  perPage={25} 
  bulkActionButtons={false} 
  filters={domainFilters} 
  actions={<ListActions />}>
		<Datagrid rowClick="edit">
			<TextField source="code" label="ID" />
			<TextField source="name" label="Name" />
		</Datagrid>
	</List>
);
class AdvertiserDomainForm extends React.Component {
  render () {
    const permissions = this.props.permissions;
    return (
      <SimpleForm toolbar={<CustomToolbar />} {...this.props}>
        { this.props.formType === "edit" && <TextField source="code" label="Domain ID" /> }
        <TextInput source="name" label="Advertiser Domain Name" style={{ width: '400px' }} validate={required()} />
        <AutocompleteArrayInput label="Google Advertiser Categories"
          source="google_categories"
          choices={googleAdsCategoryChoices}
          style={{ width: '400px' }}/>
        <AutocompleteArrayInput label="IAB Categories"
          source="iab_categories"
          choices={IABCategoryChoices}
          style={{ width: '400px' }} />
      </SimpleForm>
    );
  }
}
export const AdvertiserDomainEdit = ({ permissions, ...props }) => {
  return (
    <Edit title={<DomainTitle />} {...props}>
      <AdvertiserDomainForm formType="edit" permissions={permissions} {...props}/>
    </Edit>
  )
}
export const AdvertiserDomainCreate = ({ permissions, ...props }) => {
  return (
    <Create title={<DomainTitle />}  {...props}>
      <AdvertiserDomainForm formType="create" permissions={permissions} {...props}/>
    </Create>
  )
}
